(() => {
  angular
    .module('app')
    .controller('clinic.views.hospital.patient', [
      '$state',
      '$stateParams',
      '$filter',
      'abp.services.app.commonLookup',
      'abp.services.app.inpatientEmployee',
      controller,
    ]);

  function controller($state, $stateParams, $filter, commonLookupSvc, inpatientEmployeeSvc) {
    const vm = this;
    let hasDependentFound = false;
    vm.loading = 0;
    vm.filterText = $stateParams.filterText || '';
    vm.currencyCode = abp.setting.get('Hms.General.CurrencyCode');
    vm.searched = false;
    vm.tenantGroups = [];
    vm.employeeFoundMessage = '';
    vm.disciplines = null;
    vm.hasPanelPatientSearchForAdvancedSecurityEnhancement = abp.setting.getBoolean(
      'Hms.Feature.PanelPatientSearchForAdvancedSecurityEnhancement'
    );
    vm.employees = [];

    // Hub/ID Patient variables
    vm.hasHubIntegrationFeatureEnabled = abp.setting.getBoolean('Hms.Feature.HubIntegration');
    vm.hasSupportInternationalPatients = abp.features.isEnabled(
      'ClinicModule.SupportInternationalPatients'
    );
    vm.hubPatients = [];
    vm.hubPatientFoundMessage = '';
    vm.isHubPatientAccessible = true;

    vm.getEmployees = getEmployees;
    vm.getInternationalPatient = getInternationalPatient;

    // Init section.

    function init() {
      commonLookupSvc.getDefaultClinicLocation().success((data) => {
        setLocation(data);
        vm.patientNotFoundMessage = App.localize(
          'PatientNotFoundMessage3',
          data.accountOwnerContactNumber
        );
      });
      getSpecialistDisciplines();
    }

    function getInternationalPatient() {
      // Reset values
      vm.tenantGroups = [];
      vm.employees = [];
      vm.hubPatients = [];
      hasDependentFound = false;

      vm.loading += 1;
      inpatientEmployeeSvc
        .getPanelHubEmployees({
          filter: vm.filterText,
          panelLocationId: vm.panel.panelLocationId,
        })
        .success((data) => {
          vm.isHubPatientAccessible = data.isAccessible;
          vm.hubPatients = data.patients ?? [];

          if (vm.hubPatients.length === 0 || !vm.isHubPatientAccessible) {
            // Keep any Hub members on screen: when none of them is accessible to this
            // panel they are still shown, flagged as not accessible, alongside the
            // portal fallback results.
            getEmployees(null, vm.hubPatients.length > 0);
          }
        })
        .finally(() => {
          vm.loading -= 1;
        });
    };

    // Employee section.

    function processGetEmployeesOutput(filterText, data, callback) {
      const maxDisplayNameLength = 10;

      const allEmployees = data || [];
      vm.showNoRecords = filterText && !allEmployees.length;

      const newEmployee = {
        dependents: [],
      };

      _.each(allEmployees, (employee) => {
        if (employee.copayment) {
          if (employee.copayment.isPercentage) {
            employee.copayment = App.localize('XPerAdmission', `${employee.copayment.value}%`);
          } else {
            const valueText = $filter('currencyFormat')(employee.copayment.value, vm.currencyCode);
            employee.copayment = App.localize('XPerAdmission', valueText);
          }
        }

        employee.displayName = employee.name.substring(0, maxDisplayNameLength);

        if (employee.principalId)
          employee.displayPrincipalName = employee.principalName.substring(0, maxDisplayNameLength);

        if (vm.hasPanelPatientSearchForAdvancedSecurityEnhancement) {
          switch (employee.type) {
            case 0:
              vm.employees.push(employee);
              break;
            case 1:
              vm.employees.push(employee);
              break;
            default:
              break;
          }
        } else {
          switch (employee.type) {
            case 0:
              // HM-6630 Hack: Assign searched account as principal.
              // If there is no main account, assign any principal account as principal.
              // If main account is found,
              // assign as principal and previous principal is pushed into dependants.

              if (newEmployee.principal && !isDiff(employee.nationalId, filterText)) {
                newEmployee.dependents.push(newEmployee.principal);

                newEmployee.principal = employee;
              }

              if (!newEmployee.principal) {
                newEmployee.principal = employee;
              } else {
                newEmployee.dependents.push(employee);
              }
              break;
            case 1:
              newEmployee.dependents.push(employee);
              hasDependentFound = true;
              break;
            default:
              break;
          }
        }
      });

      if (!vm.hasPanelPatientSearchForAdvancedSecurityEnhancement) {
        newEmployee.targetIndex = isDiff(newEmployee.principal.nationalId, filterText)
          ? _.findIndex(newEmployee.dependents, 
            (d) => !isDiff(d.nationalId, filterText)) + 1 // Principal is always at first tab
          : 0;

        vm.tenantGroups.push(newEmployee);
      }

      if (_.isFunction(callback)) callback();
    }

    function getEmployees(successCallback, keepHubPatients) {
      // Reset values
      vm.tenantGroups = [];
      vm.employees = [];
      if (!keepHubPatients) vm.hubPatients = [];
      hasDependentFound = false;

      const { filterText } = vm;
      $state.transitionTo(
        $state.current,
        {
          filterText,
        },
        { notify: false }
      );

      vm.loading += 1;
      inpatientEmployeeSvc
        .getPanelEmployees({
          filter: filterText,
          panelLocationId: vm.panel.panelLocationId,
        })
        .success((data) => {
          _.each(data.items, (tenantGroup) => {
            processGetEmployeesOutput(filterText, tenantGroup.employees, successCallback);
          });

          if (!vm.hasPanelPatientSearchForAdvancedSecurityEnhancement) {
            vm.employeeFoundMessage = App.localize('EmployeeFoundMessagePart1', data.items.length);
            if (hasDependentFound) {
              vm.employeeFoundMessage += `${App.localize('EmployeeFoundMessagePart2')}.`;
            } else {
              vm.employeeFoundMessage += '.';
            }
          } else {
            vm.employeeFoundMessage = App.localize(
              'EmployeeFoundMessageVersion2',
              data.items.length
            );
          }

          vm.searched = filterText;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    };

    function setLocation(location) {
      vm.panel = {};
      vm.panel.panelLocationId = parseInt(location.value, 10) || null;
      vm.panel.name = location.name;
      vm.panel.address = location.address;
      vm.panel.contactNumber = location.contactNumber;
    }

    init();

    // Get Specialist Disciplines

    function getSpecialistDisciplines() {
      vm.loading += 1;
      commonLookupSvc
        .getSpecialistDisciplines()
        .success((data) => {
          vm.disciplines = data.items;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    /* Functions */

    // Finds if the texts are different. Return true if found different.
    // e.g. Return false if nationalId matches filter text.

    function isDiff(text1, text2) {
      return text1.replace(/-/g, '') !== text2.replace(/-/g, '');
    }
  }

  /* End of Functions */
})();
